import '../Payroll.css'
import { clearSettlementProcess } from "../../../context/PayrollProcess/SettlementActions";
import { Dialog, DialogContent } from "@material-ui/core"
import { EXTERNO_SETTLEMENTPAYROLL, GET_ALL_SETTLEMENTPAYROLL, GET_ALL_USERS_SETTLEMENT } from "../../../Querys/querys";
import { useMutation } from "@apollo/client";
import { useState, useContext } from "react";
import SettlementPayrollProcessContext from "../../../context/PayrollProcess/SettlementPayrollProcessContext";
import styles from './ExternoSettlement.module.css'

const ExternoSettlement = (props: any) => {
    const { state, dispatch } = useContext(SettlementPayrollProcessContext)
    const [activo, setactivo] = useState(false)

    const [externoPayroll] = useMutation(EXTERNO_SETTLEMENTPAYROLL, {
        refetchQueries: [{
            query: GET_ALL_SETTLEMENTPAYROLL
        },
        {
            query: GET_ALL_USERS_SETTLEMENT
        }],
    });

    const handleChange = (e: any) => {
        if (e.target.value === 'EXTERNO') {
            setactivo(true)
        } else {
            setactivo(false)
        }
    }

    const handleDelete = async () => {
        externoPayroll({
            variables: {
                externoSettlementPayrollId: state._id
            }
        })
        handleClose()
    }

    const handleClose = () => {
        clearSettlementProcess({}, dispatch)
    }

    return (
        <Dialog aria-labelledby='costumized-dialog-title' open={state.externoModal} fullWidth={false} onClose={handleClose} maxWidth={"md"}>
            <div className={styles.em_container}>
                <div className={styles.contenedorCerrarModal}>
                    <div
                        className={styles.cerrarModal}
                        onClick={() => handleClose()}>
                    </div>
                </div>
                <div className={styles.contenedorPrincipal}>
                    <div className={styles.iconoWarning}>
                    </div>
                    <div className={styles.em_titulo}>
                        ¿Confirmas marcar como externo esta baja?
                    </div>
                    <div className={styles.em_mensajePrtincipal}>
                        <span >Una vez marcado como externo no podrás recuperar la información</span>
                        <br />
                        <span className={styles.em_textoPrincipal}>Escribe EXTERNO para confirmar</span>
                        <div>
                            <input
                                className={styles.input}
                                type="text"
                                onChange={(e) => handleChange(e)}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.em_contenedorBotones}>
                <button disabled={!activo} className={activo === true ? styles.em_botonConfirmarActivo : styles.em_botonConfirmarInactivo} onClick={handleDelete} >
                    Confirmar
                </button>
            </div>
            <DialogContent>
            </DialogContent>
        </Dialog>
    )
}

export default ExternoSettlement
